import Path from './path';

/**
 * This class represents a contour made up from one or more paths
 */
export default class Contour {
    /**
     * @param {Path} paths
     */
    constructor(...paths) {
        if (paths.length === 0) throw new Error('A contour must contain at least one path');

        this.paths = paths;
        this.bounds = paths.reduce((bounds, path) => bounds.merge(path.getBounds()), paths[0].getBounds());
    }

    /**
     * @param {Array} segments
     * @return {Contour}
     */
    static fromSegments(segments) {
        return new Contour(...segments.map(segment => Path.fromSegment(segment)));
    }

    getPaths() {
        return this.paths;
    }

    getBounds() {
        return this.bounds;
    }
}
